import { JiraSoftwarePricingPageProps } from "src/pages/software/jira/pricing/jira-software-pricing-page";

import { DataCenterPromoCard } from "@/components/pricing-promos/src/data-center-promo-card";
import { TwcPromo } from "@/components/pricing-promos/src/twc-promo.tsx";
import { PricingFeatureTable } from "@/components/wpl/pricing/src/features-table";
import { QuestionsCta } from "@/components/wpl/pricing/src/index.ts";
import {
    usePricingContentContext,
    useDatacenterPlans
} from "@/components/wpl/pricing/src/pricing-content-context.tsx";
import { QuotationsAdornment } from "@/components/wpl/pricing/src/pricing-faq";
import { PricingFaq } from "@/components/wpl/pricing/src/pricing-faq/pricing-faq";
import {
    PageHeading,
    PricingPageLayout
} from "@/components/wpl/pricing/src/pricing-page-layout";
import { CallToAction } from "@/utils/pricing-queries/get-pricing-content-gql.ts";
import { ParentScrollTracking } from "@/utils/scroll-tracking/parent-scroll-tracker.tsx";

import JiraSoftwareNavV2 from "../../sections/nav-bar/software-jira-navbar";

import { JiraPriceFinder } from "./sections/jira-price-finder";

// eslint-disable-next-line complexity
export const JiraSoftwarePricingPageV2Template = (
    props: JiraSoftwarePricingPageProps
) => {
    const content = usePricingContentContext();
    const questionsCtaContent = content
        ?.callToActionContainer?.[0] as CallToAction;
    const dataCenterContent = useDatacenterPlans("Contact Us", "Learn more");

    const featuresCtaContent = content
        ?.callToActionContainer?.[1] as CallToAction;

    return (
        <PricingPageLayout
            nav={<JiraSoftwareNavV2 />}
            showFallback={content?.hasError}
        >
            <ParentScrollTracking
                scrollTrackingEnabled={true}
                pageId="jira-software-pricing-page"
            >
                <PageHeading>{content?.headline}</PageHeading>
                <JiraPriceFinder
                    pricing={props.pricing}
                    countryCode={props.countryCode}
                />
                <PricingFeatureTable
                    title={content?.compareFeaturesTitle ?? undefined}
                    comparePlans={content?.comparePlans ?? undefined}
                    compareFeatures={content?.compareFeatures ?? undefined}
                    linkValues={{
                        linkText: featuresCtaContent?.text ?? undefined,
                        linkHref: featuresCtaContent?.url ?? undefined
                    }}
                    dataProductKey={"jiraSoftware"}
                    stickyCtasEnabled={false}
                />
                <DataCenterPromoCard dataCenterContent={dataCenterContent} />
                <TwcPromo product="jira" />
                <QuotationsAdornment>
                    <ParentScrollTracking>
                        <PricingFaq
                            header={content?.getMoreDetailsTitle ?? undefined}
                            planDetails={
                                content?.additionalDetails ?? undefined
                            }
                        />
                    </ParentScrollTracking>
                </QuotationsAdornment>
                <QuestionsCta
                    product={"Jira"}
                    ctaHref={questionsCtaContent?.url ?? undefined}
                    questionsHeader={questionsCtaContent?.title ?? undefined}
                    priceAndLicensingLinkText={
                        questionsCtaContent?.text ?? undefined
                    }
                    questionsBody={
                        questionsCtaContent?.valueProposition ?? undefined
                    }
                    imageHref={questionsCtaContent?.asset?.url}
                />
            </ParentScrollTracking>
        </PricingPageLayout>
    );
};
